export default __webpack_public_path__ + "static/media/gift-icon.edc17bca.svg";